import { useState } from 'react'
import { useApp } from '../AppContext'

export default function Login() {
  const { login } = useApp()
  const [form, setForm]     = useState({ email: 'jean.dupont@example.com', password: 'hubspot123' })
  const [error, setError]   = useState('')
  const [loading, setLoading] = useState(false)

  const f = k => e => setForm(p => ({ ...p, [k]: e.target.value }))

  async function submit(e) {
    e.preventDefault()
    setLoading(true); setError('')
    try { await login(form.email, form.password) }
    catch (err) { setError(err.message) }
    finally { setLoading(false) }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg2)' }}>
      <div style={{ width: 400, background: 'var(--bg)', borderRadius: 'var(--radius-xl)', padding: 36, boxShadow: 'var(--shadow-lg)', border: '1px solid var(--border)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 36, fontWeight: 800, color: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            <i className="ti ti-hexagon" />
            HubSpot
          </div>
          <p style={{ color: 'var(--text3)', fontSize: 13, marginTop: 4 }}>Logiciel de facturation</p>
        </div>

        {error && <div className="alert error">{error}</div>}

        <form onSubmit={submit}>
          <div className="form-group">
            <label className="form-label req">Adresse email</label>
            <input type="email" className="form-control" value={form.email} onChange={f('email')} required autoFocus />
          </div>
          <div className="form-group">
            <label className="form-label req">Mot de passe</label>
            <input type="password" className="form-control" value={form.password} onChange={f('password')} required />
          </div>
          <button type="submit" className="btn primary" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} disabled={loading}>
            <i className="ti ti-login" />
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>

        <p style={{ marginTop: 18, fontSize: 12, color: 'var(--text3)', textAlign: 'center' }}>
          Démo · jean.dupont@example.com / hubspot123
        </p>
      </div>
    </div>
  )
}
